import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { SDirectionSelection } from '@slg/web-customer-shared';
import { useStore, useGtm } from '@/composables';


const __default__ = {
  name: 'DirectionSelection',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['clearBookingRequestError'],
  setup(__props, { emit }) {


const store = useStore();
const { trackGtmEvent } = useGtm();

const getArrivalPlace = computed(() => store.getters['booking/getArrivalPlace']);
const getDeparturePlace = computed(() => store.getters['booking/getDeparturePlace']);
const getIsArrivalPlaceFilled = computed(() => store.getters['booking/isArrivalPlaceFilled']);
const getIsDeparturePlaceFilled = computed(() => store.getters['booking/isDeparturePlaceFilled']);
const isOpsZoneSelected = computed(() => store.getters['opsZone/isOpsZoneSelected']);
const getUserProfile = computed(() => store.getters['auth/getUserProfile']);
const getAppConfig = computed(() => store.getters['common/getAppConfig']);
const getCommuneCoordinatesForMap = computed(() => getUserProfile.value?.communeCoordinates || []);
const isNightCardsSupport = computed(() => !!(getAppConfig.value && getAppConfig.value.isNightCardsSupport));
const opsZoneMapFill = computed(() => (getAppConfig.value && getAppConfig.value.opsZoneMapFill) || '');
const opsZoneMapStroke = computed(() => (getAppConfig.value && getAppConfig.value.opsZoneMapStroke) || '');
const communeMapFill = computed(() => (getAppConfig.value && getAppConfig.value.communeMapFill) || '');
const communeMapStroke = computed(() => (getAppConfig.value && getAppConfig.value.communeMapStroke) || '');

function onSelectDeparturePlace() {
  trackGtmEvent('Select Pick Up address button click', 'Button', 'Click', '');
}

function onSelectArrivalPlace() {
  trackGtmEvent('Select Drop Off address button click', 'Button', 'Click', '');
}

function setDeparturePlace(data: unknown) {
  store.commit('booking/setDeparturePlace', data);
  emit('clearBookingRequestError');
}

function setArrivalPlace(data: unknown) {
  store.commit('booking/setArrivalPlace', data);
  emit('clearBookingRequestError');
}

function clearBookingForm() {
  if (isOpsZoneSelected.value) {
    store.commit('booking/clearDates');
    store.commit('booking/clearOptions');
    store.commit('opsZone/clearOpsZone');
  }
}

function onTrackEventFromInput() {
  trackGtmEvent('From input click', 'Input', 'Click', 'Open dialog with map and poi list');
  trackGtmEvent('Pop-up with map and poi list opened', 'Pop-up', 'Opened', '');
}

function onTrackEventToInput() {
  trackGtmEvent('To input click', 'Input', 'Click', 'Open dialog with map and poi list');
  trackGtmEvent('Pop-up with map and poi list opened', 'Pop-up', 'Opened', '');
}

return { __sfc: true,emit, store, trackGtmEvent, getArrivalPlace, getDeparturePlace, getIsArrivalPlaceFilled, getIsDeparturePlaceFilled, isOpsZoneSelected, getUserProfile, getAppConfig, getCommuneCoordinatesForMap, isNightCardsSupport, opsZoneMapFill, opsZoneMapStroke, communeMapFill, communeMapStroke, onSelectDeparturePlace, onSelectArrivalPlace, setDeparturePlace, setArrivalPlace, clearBookingForm, onTrackEventFromInput, onTrackEventToInput, SDirectionSelection }
}

})